import * as React from 'react';
import { Form, Col, Row, Button } from 'react-bootstrap';
import { Bloodwork, BloodworkNote, Section } from '../../models';
import { BloodworkEntryStore } from '../../stores/bloodwork-entry-store';

type Props = {
    section: Section;
    title: string;
    bloodwork: Bloodwork;
    bloodworkEntryStore: BloodworkEntryStore
};

type State = {
    bloodworkNote: BloodworkNote;
};

export class BloodworkNotes extends React.Component<Props, {}> {
    state: State = {
        bloodworkNote: this.initBloodworkNote(this.props.section, this.props.bloodwork),
    }

    componentWillReceiveProps(nextProps) {
        const { section, bloodwork } = nextProps;
        this.setState({
            bloodworkNote: this.initBloodworkNote(section, bloodwork),
        });
    }

    initBloodworkNote(section: string, bloodwork: Bloodwork): BloodworkNote {
        if (bloodwork && bloodwork.bloodworkNotes) {
            let bloodworkNote = bloodwork.bloodworkNotes.findNote(section);
            if (!bloodworkNote) {
                bloodworkNote = bloodwork.bloodworkNotes.addNote(section, '');
            } 
            return new BloodworkNote(bloodworkNote);
        }
        return new BloodworkNote(); 
    }

    handleInputChange = (event: any) => {
        const { section } = this.props;
        const value = event.target.value;
        this.setState({
            bloodworkNote: new BloodworkNote({section, text: value}),
        });
    }

    saveOrUpdate = (event: any) => {
        const { section, bloodwork, bloodworkEntryStore } = this.props;
        event.preventDefault();
        const bloodworkNote = bloodwork.bloodworkNotes.findNote(section);
        bloodworkNote.text = this.state.bloodworkNote.text;
        bloodworkEntryStore.saveBloodwork(bloodwork);
    }

    render() {
        const { title } = this.props;
        return (
            <Form id="notes-form">
                <Form.Group controlId="exampleForm.ControlTextarea1">
                    <Form.Label>{title}</Form.Label>
                    <Form.Control as="textarea" rows="6"
                        name="notes-text" 
                        value={this.state.bloodworkNote.text}
                        onChange={this.handleInputChange}
                    />
                </Form.Group>
                <Form.Group as={Row}>
                    <Col>
                        <Button id="submitButton" type="submit" onClick={this.saveOrUpdate}>Save</Button>
                    </Col>
                </Form.Group>
            </Form>
        );
    }
}